// extracted by mini-css-extract-plugin
export default {"banner":"RetentionDateExpiredBanner_banner__uLbMn"};